import React from "react";

const BatchManagement = ({ PageName, IconName }) => {
  const Color = PageName === IconName ? "#4C34AD" : "#fff";
  return (
    <div className="ml-0 flex items-center gap-4">
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="20.064" viewBox="0 0 30 20.064">
        <path id="Path_94824" data-name="Path 94824" d="M22.81,5,32,15.02,22.81,25.04l-3.072-3.35-3.093,3.373-2.74-2.987L11.19,25.04,2,15.02,11.19,5l2.737,2.985-.961,1.048L11.19,7.1,3.923,15.02l7.267,7.924,1.755-1.915-5.49-5.985,9.19-10.02,3.071,3.348ZM16.646,7.12,9.379,15.044l7.267,7.924,2.13-2.325L13.62,15.02l5.135-5.6Z" transform="translate(-2 -5)" fill="#fff"/>
      </svg>

      <p className="font-bold text-white">Batch Management</p>
    </div>
  );
};

export default BatchManagement;
